// react
import { createContext, type ReactNode, useContext } from 'react';

// material ui
import { type AlertColor } from '@mui/material';

export interface GlobalAlertModel {
  severity: AlertColor;
  title?: string;
  message: ReactNode;
  action?: ReactNode;
  ownerId?: string;
}

export interface GlobalAlertContextValue {
  alert: GlobalAlertModel | null;
  showAlert: (alert: GlobalAlertModel) => void;
  clearAlert: (ownerId?: string) => void;
}

export const GlobalAlertContext = createContext<
  GlobalAlertContextValue | undefined
>(undefined);

export function useGlobalAlert() {
  const context = useContext(GlobalAlertContext);

  if (!context) {
    throw new Error('useGlobalAlert must be used within GlobalAlertProvider');
  }

  return context;
}
